import { GridIcon } from "./icons/GridIcon";
import { WifiIcon } from "./icons/WifiIcon";
import { SeatingIcon } from "./icons/SeatingIcon";
import { AccessibleIcon } from "./icons/AccessibleIcon";
import { BarIcon } from "./icons/BarIcon";
import { TaxiIcon } from "./icons/TaxiIcon";
import { CoffeeIcon } from "./icons/CoffeeIcon";
import { ParkingIcon } from "./icons/ParkingIcon";
import { PublicTransportIcon } from "./icons/PublicTransportIcon";
import { PetFriendlyIcon } from "./icons/PetFriendlyIcon";
import { RestroomIcon } from "./icons/RestroomIcon";
import { ChildFriendlyIcon } from "./icons/ChildFriendlyIcon";
import { LodgingIcon } from "./icons/LodgingIcon";
import { GymIcon } from "./icons/GymIcon";
import { OutdoorTerraceIcon } from "./icons/OutdoorTerraceIcon";
import { RestaurantIcon } from "./icons/RestaurantIcon";
import SectionCard from "./section-card";
import SectionHeader from "./section-header";

const NEUTRAL_500 = "#767c83";

/*
 * The 15 supported facility keys mapped to their icons, mirroring the
 * reference facilities card.
 */
const FACILITY_ICON_MAP = {
  wifi: WifiIcon,
  "public-transport": PublicTransportIcon,
  seating: SeatingIcon,
  parking: ParkingIcon,
  "pet-friendly": PetFriendlyIcon,
  accessible: AccessibleIcon,
  restroom: RestroomIcon,
  "child-friendly": ChildFriendlyIcon,
  lodging: LodgingIcon,
  taxi: TaxiIcon,
  gym: GymIcon,
  "outdoor-terrace": OutdoorTerraceIcon,
  restaurant: RestaurantIcon,
  bar: BarIcon,
  coffee: CoffeeIcon,
};

const EventFacilitiesCard = ({ facilities, title, titleFont }) => {
  /* Only keep facilities we can actually render an icon for; otherwise the
   * card would show an empty header/divider with no icons (the nested model
   * may include keys that aren't in FACILITY_ICON_MAP). */
  const renderable = (facilities || []).filter(
    (facility) => FACILITY_ICON_MAP[facility],
  );
  if (renderable.length === 0) return null;

  return (
    <SectionCard
      className="flex w-full flex-col items-center justify-center p-[10px]"
      id="facilitiesBlock"
    >
      <SectionHeader
        icon={<GridIcon size={20} color={NEUTRAL_500} />}
        title={title}
        titleFont={titleFont}
      />
      <div className="mb-[15px] h-px w-full rounded-full bg-event-85" />
      <div className="mb-[20px] mt-[20px] flex w-full flex-col items-center justify-center px-[10px]">
        <div className="grid w-full grid-cols-4 items-center justify-center gap-3">
          {renderable.map((facility, index) => {
            const Icon = FACILITY_ICON_MAP[facility];
            return (
              <div
                key={`${facility}-${index}`}
                className="mb-[10px] flex items-center justify-center"
              >
                <div className="flex h-[40px] w-[40px] items-center justify-center rounded-full bg-event-55 xs:h-[50px] xs:w-[50px]">
                  <Icon size={24} color={NEUTRAL_500} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </SectionCard>
  );
};

export default EventFacilitiesCard;
